export default __webpack_public_path__ + "static/media/pharmacy01.57082654.PNG";